var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon11({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56539 22.3146H0V1H25.8067V16.6665H22.5803V4.54759H3.2253V18.7623H9.56539V22.3146Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9991 38.9996H8.38281V16.0859H39.9959L39.9991 38.9996ZM11.6123 35.4474H36.7706V19.6382H11.6123V35.4474Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8601 34.7004L13.2969 30.1245L15.6864 27.7453L17.8601 29.9305L24.6076 23.1841L27.976 26.5573L33.5266 21L35.9109 23.3855L27.976 31.3283L24.5991 27.9551L17.8601 34.7004Z",
    fill: "#2650FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1633 27.5361L17.7422 29.9606L20.1633 32.3851L22.5844 29.9606L20.1633 27.5361Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0601 30.1241V30.1188L15.6759 27.7344L13.2969 30.1188L15.4874 32.3145L17.8717 34.7L20.2559 32.3145L18.0601 30.1241Z",
    fill: "#FFBC07"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 14,
    height: 4,
    fill: "#FFBC07"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 1,
    width: 12,
    height: 4,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 5,
    width: 12,
    height: 4,
    transform: "rotate(90 26 5)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 4,
    transform: "rotate(90 4 5)",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 23,
    height: 4,
    transform: "rotate(90 12 16)",
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 22,
    width: 9,
    height: 4,
    transform: "rotate(-180 9 22)",
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 31,
    height: 4,
    transform: "rotate(-180 40 20)",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon11);
export default __webpack_public_path__ + "static/media/feature_icon_1_1.4214feaf855a65134cfa9e0b3f788ef3.svg";
export { ForwardRef as ReactComponent };